import React from 'react'

export default function LoadingIndicator(props) {
  return props.data ?
    props.children
    : (
      <>
        <div className="rounded-md pt-4 w-full mx-auto">
          <div className="animate-pulse flex items-center space-x-4">
            {/* <div className="rounded-full bg-gray-200 h-16 w-16"></div> */}
            <div className="flex-1 space-y-4 py-1">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            </div>
          </div>
          <div className="animate-pulse flex items-center space-x-4 mt-5">
            {/* <div className="rounded-full bg-gray-200 h-16 w-16"></div> */}
            <div className="flex-1 space-y-4 py-1">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            </div>
          </div>
          <div className="animate-pulse flex items-center space-x-4 mt-5">
            {/* <div className="rounded-full bg-gray-200 h-16 w-16"></div> */}
            <div className="flex-1 space-y-4 py-1">
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="space-y-2">
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
}
